export type DashboardSectionId =
  | 'customer-dashboard'
  | 'key_goals'
  | 'projects'
  | 'relationship-map'
  | 'technology_alignment'
  | 'art-of-the-possible'
  | 'transformation-graph'
  | 'business_frameworks'
  | 'critical_application';

export interface DashboardSection {
  id: DashboardSectionId;
  navLabel: string;
}

export const DASHBOARD_SECTIONS: DashboardSection[] = [
  { id: 'customer-dashboard', navLabel: 'Top' },
  { id: 'key_goals', navLabel: 'Goals, Priorities & Industry Trends' },
  { id: 'projects', navLabel: 'Projects' },
  { id: 'relationship-map', navLabel: 'Project Map' },
  { id: 'technology_alignment', navLabel: 'Technology Alignment' },
  { id: 'art-of-the-possible', navLabel: 'Art Of Possible' },
  { id: 'transformation-graph', navLabel: 'Maturity Graph' },
  { id: 'business_frameworks', navLabel: 'Frameworks' },
  { id: 'critical_application', navLabel: 'Top 10 Critical Applications' },
];

export function getDashboardSectionAnchorId(sectionId: DashboardSectionId): string {
  return `dashboard-section-${sectionId}`;
}
